export default class DiffLine {
  type: string;

  text: string;

  constructor(obj: any = {}) {
    this.type = obj.type || 'context';
    this.text = obj.text || '';
  }

  public static of(obj: any = {}): DiffLine {
    return new DiffLine(obj);
  }

  public static ofList(obj: any[] = []): DiffLine[] {
    return obj.map(this.of);
  }

  get isAdd(): boolean {
    return this.type === 'ADD';
  }

  get isDel(): boolean {
    return this.type === 'DEL';
  }
}
